module.exports = __webpack_public_path__ + "img/ururu.e3ebec58.png";